import React from 'react';
import PropTypes from 'prop-types';

const ImageActionOverlay = ({
  showPrimaryAction,
  primaryLabel,
  menuActions,
  onPrimaryAction,
}) => {
  const actions = Array.isArray(menuActions) ? menuActions.filter(Boolean) : [];

  if (!showPrimaryAction && actions.length === 0) {
    return null;
  }

  return (
    <div className="recreate-image-tile__overlay">
      <div
        className="recreate-image-tile__controls"
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
      >
        {showPrimaryAction && (
          <button
            type="button"
            className="recreate-image-tile__cta"
            onClick={onPrimaryAction}
          >
            {primaryLabel}
          </button>
        )}
        {actions.length > 0 && (
          <div className="recreate-image-tile__menu">
            {actions.map((action) => (
              <button
                key={action.key || action.label}
                type="button"
                className={action.className || undefined}
                onClick={action.onClick}
              >
                {action.iconClassName && <i className={action.iconClassName} aria-hidden="true" />}
                <span>{action.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

ImageActionOverlay.propTypes = {
  showPrimaryAction: PropTypes.bool,
  primaryLabel: PropTypes.string,
  menuActions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string.isRequired,
    iconClassName: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
  })),
  onPrimaryAction: PropTypes.func,
};

ImageActionOverlay.defaultProps = {
  showPrimaryAction: true,
  primaryLabel: 'Recreate',
  menuActions: [],
  onPrimaryAction: undefined,
};

export default ImageActionOverlay;
